import { connect } from 'react-redux'
import { getMe, fetchMe, updateUserToken,uploadImage } from '../../store/user/duck'
import { fetchCustomer ,addNewTruck,fetchDriversByCustomerId,updateDriver} from '../../store/customer/duck'
import {fetchContainers} from "../../store/container/duck"
import AddTruckComponent from './component'
import { createDriver,driverDetails } from '../../store/driver/duck';

const AddDriverContainer = connect(
  // Map state to props
  state => ({
    user: state.user.user,
    userPhase: state.user.userPhase
  }),
  {
    getMe,
    fetchMe,
    updateUserToken,
    fetchCustomer,
    fetchContainers,
    addNewTruck,
    createDriver,
    updateDriver,
    uploadImage,
    fetchDriversByCustomerId,
    driverDetails
  }
)(AddTruckComponent)

export default AddDriverContainer
